import { NavLink } from 'react-router-dom'
import { Home, Calendar, MessageSquare, Sparkles, Users, type LucideIcon } from 'lucide-react'

interface MobileNavItem {
  to: string
  label: string
  icon: LucideIcon
  dataTour?: string
}

/**
 * Mobile bottom-tab navigation. The five most-used surfaces — anything else
 * lives behind the header search / palette.
 *
 * Visible only on small screens (`lg:hidden`). Sits above the main content
 * with a generous safe-area inset so it never collides with the home
 * indicator on iOS.
 */
const ITEMS: MobileNavItem[] = [
  { to: '/dashboard', label: 'Home', icon: Home, dataTour: 'nav-dashboard' },
  { to: '/calendar', label: 'Calendar', icon: Calendar, dataTour: 'nav-calendar' },
  { to: '/bulletin', label: 'Bulletin', icon: MessageSquare, dataTour: 'nav-bulletin' },
  { to: '/help', label: 'Help', icon: Sparkles },
  { to: '/directory', label: 'Directory', icon: Users, dataTour: 'nav-directory' },
]

const MobileNav = () => {
  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-paper/95 backdrop-blur-md border-t border-mist/50 pb-[env(safe-area-inset-bottom)]"
      aria-label="Primary navigation"
    >
      <ul className="grid grid-cols-5">
        {ITEMS.map((item) => {
          const Icon = item.icon
          return (
            <li key={item.to}>
              <NavLink
                to={item.to}
                data-tour={item.dataTour}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center gap-1 py-2.5 text-[0.65rem] uppercase tracking-eyebrow font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary/60 rounded-lg ${
                    isActive ? 'text-primary' : 'text-slate hover:text-deepwater'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={`relative w-10 h-7 rounded-full flex items-center justify-center transition-colors ${
                        isActive ? 'bg-primary/10' : ''
                      }`}
                    >
                      <Icon className="w-4 h-4" />
                    </span>
                    {item.label}
                  </>
                )}
              </NavLink>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default MobileNav
